import strikepay_black from '../images/strikepay_Mark_RGB_Black.png';
import strikepay_white from '../images/strikepay_Mark_RGB_White.png';
import strikepay_url_white_lg from '../images/strikepay_Mark_url_RGB_White.png';
import strikepay_url_white_sm from '../images/strikepay_Mark_url_RGB_White_small.png';
import strikepay_poweredby_black from '../images/strikepay_Mark_poweredby_RGB_Black.png';
import striketip_black from '../images/striketip_black_text.png'; // eslint-disable-line import/extensions
import striketip_white from '../images/striketip_white_text.png'; // eslint-disable-line import/extensions
import striketip_url_white from '../images/striketip_white_text_url.png'; // eslint-disable-line import/extensions
import striketip_url_black from '../images/striketip_black_text_url.png'; // eslint-disable-line import/extensions
import brand_icon from '../images/strikepay_qr_icon.png';

/**
 * Brand is product-based: tipping → striketip, payment/giving → strikepay.
 * Default is striketip (primary and default). Domain is no longer used for branding.
 * @param {string} [brand] - 'striketip' | 'strikepay'. Defaults to 'striketip'.
 */
function useStrikepay(brand) {
  return brand === 'strikepay';
}

/** Black-text logo for light backgrounds. */
export function getLogo(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_black : striketip_black;
}

/** White-text logo for dark backgrounds. */
export function getLogoDark(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_white : striketip_white;
}

/** Sidebar expanded logo (dark navbar). With URL. */
export function getSidebarLogoLg(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_url_white_lg : striketip_url_white;
}

/** Sidebar collapsed / compact logo (dark navbar). */
export function getSidebarLogoSm(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_url_white_sm : striketip_white;
}

/** Logo with URL for light backgrounds. */
export function getLogoWithUrl(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_black : striketip_url_black;
}

export function getPoweredByLogo(brand = 'striketip') {
  return useStrikepay(brand) ? strikepay_poweredby_black : striketip_black;
}

/** Icon-only mark for mobile navbar. Same icon for both brands. */
export function getBrandIconDark() {
  return brand_icon;
}

export function getBrandName(brand = 'striketip') {
  return useStrikepay(brand) ? 'strikepay' : 'striketip';
}

export function getBrandUrl(brand = 'striketip') {
  return useStrikepay(brand) ? 'https://www.strikepay.co' : 'https://www.striketip.com';
}

export { strikepay_black, strikepay_white, striketip_black, striketip_white };
